import React, { useState, useRef } from "react";
import './addcustomer.css';
import user from '../assets/images/user.png';

const AddCustomer = ({ onCustomerAdd, onClose, customer }) => {
    const [img, setImg] = useState(customer?.img || null); // Initialize with existing image or null
    const [firstname, setFirstName] = useState(customer?.firstname || '');
    const [lastname, setLastName] = useState(customer?.lastname || '');
    const [phone, setPhone] = useState(customer?.phone || '');
    const [email, setEmail] = useState(customer?.email || '');
    const [membership, setMembership] = useState(customer?.membership || '');
    const [error, setError] = useState({});
    const fileInputRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const formData = new FormData();
            formData.append("firstname", firstname);
            formData.append("lastname", lastname);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("membership", membership);
            if (fileInputRef.current.files[0]) {
                formData.append("img", fileInputRef.current.files[0]);
            }
            onCustomerAdd(formData); // Pass FormData for image upload
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'firstname') setFirstName(value);
        if (name === 'lastname') setLastName(value);
        if (name === 'phone') setPhone(value);
        if (name === 'email') setEmail(value);
        if (name === 'membership') setMembership(value);

        validateUser({ name, value });
    };

    const validateUser = ({ name, value }) => {
        let errorMsg = '';
        switch (name) {
            case 'firstname':
                if (value.length < 5) {
                    errorMsg = ' enter  minimum of 5 characters';
                } else if (!/^[a-zA-Z]+$/.test(value)) {
                    errorMsg = 'Please enter alphabets only';
                }
                break;

            case 'lastname':
                if (value.length < 2) {
                    errorMsg = ' enter a minimum of 2 characters';
                } else if (!/^[a-zA-Z]+$/.test(value)) {
                    errorMsg = 'Please enter alphabets only';
                }
                break;

            case 'email':
                if (!/\S+@\S+\.\S+/.test(value)) {
                    errorMsg = 'Please enter a valid email';
                }
                break;

            case 'phone':
                if (!/^\d{10}$/.test(value)) {
                    errorMsg = 'Please enter a 10-digit phone number';
                }
                break;

            case 'membership':
                if (value !== 'member' && value !== 'non-member') {
                    errorMsg = 'Please select a valid membership';
                }
                break;

            default:
                break;
        }
        setError({ ...error, [name]: errorMsg });
    };

    const validateForm = () => {
        return Object.values(error).every((err) => err === '') &&
               firstname && lastname && email && phone && membership;
    };

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImg(reader.result);  // Store the image URL in the state
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="modal-overlay">
            <div className="form-container">
                <h3>Add Customer</h3>
                <div className="img-container">
                    <button className="new" onClick={triggerFileInput}>
                        <img src={img || user} alt="logo" /> {/* Display uploaded image or default */}
                    </button>
                    <input type="file" accept="image/*" onChange={handleFile} ref={fileInputRef} style={{ display: 'none' }} />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="input-box">
                        <input type="text" name="firstname" value={firstname} onChange={handleChange} autoComplete="off" />
                        <label>Firstname</label>
                        {error.firstname && <small style={{ color: "red" }}>{error.firstname}</small>}
                    </div>

                    <div className="input-box">
                        <input type="text" name="lastname" value={lastname} onChange={handleChange} autoComplete="off" />
                        <label>Lastname</label>
                        {error.lastname && <small style={{ color: "red" }}>{error.lastname}</small>}
                    </div>

                    <div className="input-box">
                        <input type="text" name="email" value={email} onChange={handleChange} autoComplete="off" />
                        <label>Email</label>
                        {error.email && <small style={{ color: "red" }}>{error.email}</small>}
                    </div>

                    <div className="input-box">
                        <input type="text" name="phone" value={phone} onChange={handleChange} autoComplete="off" />
                        <label>Phone</label>
                        {error.phone && <small style={{ color: "red" }}>{error.phone}</small>}
                    </div>

                    <div>
                        <select name="membership" value={membership} onChange={handleChange} required>
                            <option value="" disabled>Select Membership</option>
                            <option value="member">Member</option>
                            <option value="non-member">Non-member</option>
                        </select>
                    </div>

                    <div className="btn-container">
                    <button type="button" className="back-btn" onClick={onClose}>Back</button>
                    <button className="add-btn" type="submit">Add</button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default AddCustomer;



 